// routes
import {
  AccessTime,
  AssignmentInd,
  Bookmark,
  Dashboard,
  FactCheck,
  GroupAdd,
  Insights,
  Outbox,
  PlayArrow,
  SatelliteAlt,
  Schedule,
  Settings,
  Stop,
  Summarize,
  SwitchAccount,
  TravelExplore,
  Troubleshoot,
  Tune,
  ViewList,
  WifiTetheringError,
} from '@mui/icons-material';
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: <Dashboard />,
  watchlist: <Bookmark />,
  menuItem: getIcon('ic_menu_item'),
  forwarder: getIcon('ic_forwarder'),
  operator: getIcon('ic_operator'),
  insurer: getIcon('ic_insurer'),
  insurerClientApplication: getIcon('ic_insurer_application'),
  loanClientApplications: getIcon('ic_loan_application'),
  project: getIcon('ic_project'),
  entries: getIcon('ic_entries'),
  userList: <SwitchAccount />,
  filterTradesIcon: <Tune />,
  suspiciousTicksIcon: <TravelExplore />,
  tradeAnalysisIcon: <Insights />,
  deltaAlertTradesIcon: <WifiTetheringError />,
  userProfile: getIcon('ic_user_profile'),
  reports: <Summarize />,
  deltaAnalyzerIcon: <SatelliteAlt />,
  weekelyReports: <Troubleshoot />,
  broadcast: <Outbox />,
  ledgerReports: <AssignmentInd />,
  scriptsTiming: <Schedule />,
  customFiltersIcon: <FactCheck />,
  positions: <ViewList />,
  activeTrades: <PlayArrow />,
  closedTrades: <Stop />,
  subAdminUser: <GroupAdd />,
  settings: <Settings />,
  nseMarketTiming: <AccessTime />,
  changePassword: <Settings />,
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: 'management',
    items: [
      { title: 'dashboard', path: PATH_DASHBOARD.general.dashboard, icon: ICONS.dashboard },
      { title: 'Watchlist', path: PATH_DASHBOARD.watchlist.root, icon: ICONS.watchlist },
      { title: 'Admins', path: PATH_DASHBOARD.operator.root, icon: ICONS.userList },
      { title: 'Sub Admins', path: PATH_DASHBOARD.operator.subAdminRoot, icon: ICONS.subAdminUser },
      { title: 'Message BroadCast', path: PATH_DASHBOARD.messageBroadCast.root, icon: ICONS.broadcast },
      {
        title: 'Positions',
        icon: ICONS.positions,
        path: PATH_DASHBOARD.operator.positions.grouped.root,
        children: [
          { title: 'Active', path: PATH_DASHBOARD.operator.positions.grouped.active, icon: ICONS.activeTrades },
          { title: 'Closed', path: PATH_DASHBOARD.operator.positions.grouped.closed, icon: ICONS.closedTrades },
        ],
      },
      {
        title: 'Delta Analyzer',
        icon: ICONS.deltaAnalyzerIcon,
        children: [
          {
            title: 'Delta Alert Trades',
            path: PATH_DASHBOARD.deltaAnalyzer.deltaAlertTrades,
            icon: ICONS.deltaAlertTradesIcon,
          },
          { title: 'Trade Analysis', path: PATH_DASHBOARD.deltaAnalyzer.tradeAnalysis, icon: ICONS.tradeAnalysisIcon },
          { title: 'Custom Filters', path: PATH_DASHBOARD.deltaAnalyzer.customFilters, icon: ICONS.customFiltersIcon },
          { title: 'Filter Trades', path: PATH_DASHBOARD.deltaAnalyzer.filterTrades, icon: ICONS.filterTradesIcon },
          {
            title: 'Suspicious Ticks',
            path: PATH_DASHBOARD.deltaAnalyzer.suspiciousTicks,
            icon: ICONS.suspiciousTicksIcon,
          },
        ],
      },
      {
        title: 'Reports',
        icon: ICONS.reports,
        children: [
          {
            title: 'Risk Report',
            path: PATH_DASHBOARD.report.riskyUser,
            icon: ICONS.weekelyReports,
          },
          {
            title: 'Ledger Reports',
            path: PATH_DASHBOARD.report.clientLedger,
            icon: ICONS.ledgerReports,
          },
          {
            title: 'Scripts Timing',
            path: PATH_DASHBOARD.report.scriptsTiming,
            icon: ICONS.scriptsTiming,
          },
        ],
      },
      {
        title: 'Settings',
        icon: ICONS.settings,
        children: [
          {
            title: 'NSE Market Timing',
            path: PATH_DASHBOARD.setting.nseMarketTiming,
            icon: ICONS.nseMarketTiming,
          },
          {
            title: 'Change Password',
            path: PATH_DASHBOARD.setting.changePassword,
            icon: ICONS.changePassword,
          },
        ],
      },
    ],
  },
];

export default navConfig;
